'use client';
import { useEffect } from 'react';

export const usePreventScroll = (isOpen: boolean) => {

  useEffect(() => {
    if (isOpen) {
      // lenis?.stop();
      // lenis?.

      // Save current scroll position
      const scrollY = window.scrollY;

      // Add styles to prevent scroll
      // document.body.style.position = 'fixed';
      document.body.style.width = '100%';
      document.body.style.top = `-${scrollY}px`;

      // Cleanup function
      return () => {
        // Remove styles and restore scroll position
        document.body.style.position = '';
        document.body.style.width = '';
        document.body.style.top = '';
        window.scrollTo(0, scrollY);
      };
    }
  }, [isOpen]);
};
